import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-cyber-dark bg-opacity-80 backdrop-blur-md border-t border-cyber-primary py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-xianxia text-cyber-primary mb-4">天道宗</h3>
            <p className="text-cyber-light text-sm">
              天道宗是一个结合传统仙侠文化与现代科技的修炼组织，致力于探索人类潜能与科技的结合点，实现身心灵的全面提升。
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-cyber text-cyber-secondary mb-3">修炼体系</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/cultivation" className="text-cyber-light hover:text-cyber-primary transition duration-300 text-sm">
                  修炼系统
                </Link>
              </li>
              <li>
                <Link to="/artifact-refining" className="text-cyber-light hover:text-cyber-primary transition duration-300 text-sm">
                  炼器系统
                </Link>
              </li>
              <li>
                <Link to="/divination" className="text-cyber-light hover:text-cyber-primary transition duration-300 text-sm">
                  占卜系统
                </Link>
              </li>
              <li>
                <Link to="/telomere-testing" className="text-cyber-light hover:text-cyber-primary transition duration-300 text-sm">
                  寿命检测
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-cyber text-cyber-secondary mb-3">宗门服务</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/virtual-currency" className="text-cyber-light hover:text-cyber-primary transition duration-300 text-sm">
                  功德点系统
                </Link>
              </li>
              <li>
                <Link to="/quest-system" className="text-cyber-light hover:text-cyber-primary transition duration-300 text-sm">
                  任务系统
                </Link>
              </li>
              <li>
                <Link to="/disciple-profile" className="text-cyber-light hover:text-cyber-primary transition duration-300 text-sm">
                  弟子档案
                </Link>
              </li>
              <li>
                <Link to="/ar-view" className="text-cyber-light hover:text-cyber-primary transition duration-300 text-sm">
                  AR法器展示
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-cyber text-cyber-secondary mb-3">关注我们</h4>
            <div className="flex space-x-4 mb-4">
              <a href="#" className="text-cyber-light hover:text-cyber-primary transition duration-300">
                <i className="fab fa-weixin text-xl"></i>
              </a>
              <a href="#" className="text-cyber-light hover:text-cyber-primary transition duration-300">
                <i className="fab fa-weibo text-xl"></i>
              </a>
              <a href="#" className="text-cyber-light hover:text-cyber-primary transition duration-300">
                <i className="fab fa-bilibili text-xl"></i>
              </a>
              <a href="#" className="text-cyber-light hover:text-cyber-primary transition duration-300">
                <i className="fab fa-github text-xl"></i>
              </a>
            </div>
            <p className="text-cyber-light text-sm">
              <i className="fas fa-map-marker-alt mr-2"></i>
              线下道场: 中国科技城，赛博修真园区88号
            </p>
          </div>
        </div>
        
        <div className="mt-8 pt-4 border-t border-cyber-primary text-center text-cyber-light text-sm">
          <p>&copy; {new Date().getFullYear()} 天道宗 - 赛博修仙. 保留所有权利.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
